import { IRequest } from '@r1-frontend/shared/types/IRequest';

export interface IResponseDto {
    isActualData: boolean,
}

/*
* Проверяет требуется ли обновление паспортных данных
* https://master.core-profile.sandbox.d2c.r-one.io/docs#/User/UserController_checkPassport
*/
export const checkPassport = (): IRequest => ({
    uri: '/v1/user/check-passport',
    method: 'GET',
    withAuth: true,
    withProvider: true,
});
